module.exports = __webpack_public_path__ + "img/envelope.a00f3e47.png";